import React, { useState } from 'react';
import { updatePackage } from '../../api/userData';
import LimitAndWeekendSettings from '../Cards/LimitAndWeekendSettings';

const ChangingLimitModal = ({ isOpen, onClose, packageData, refreshFlows }) => {
  const [limit, setLimit] = useState(packageData?.limit || 100);
  const [noWeekend, setNoWeekend] = useState(packageData?.noWeekend || false);
  
  if (!isOpen) return null;
  const handleSave = async () => {
    // Вызываем API
    await updatePackage(
      packageData.integration_id,
      packageData.id,
      packageData.price,
      limit,
      noWeekend
    );
    
    // Обновляем потоки
    refreshFlows();
    // Закрываем модальное окно
    onClose();
  };

  return (
    <div className="modal-overlay" onClick={onClose}>
      <div 
        className="modal small bottom-right open" 
        onClick={(e) => e.stopPropagation()}
      >
        <div className="modal-header">
          <h3>Изменение лимита</h3>
        </div>
        <div className="modal-body">
          <LimitAndWeekendSettings
            limit={limit}
            onLimitChange={setLimit}
            noWeekend={noWeekend}
            onNoWeekendChange={setNoWeekend}
          />
        </div>
        <div className="modal-footer">
          <button 
            className="btn btn-primary-filled"
            onClick={handleSave}
          >
            Отправить на модерацию
          </button>
        </div>
      </div>
    </div>
  );
};

export default ChangingLimitModal;
